var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10085 13.8276C8.42454 13.8276 9.4976 12.8275 9.4976 11.5937C9.4976 10.36 8.42454 9.35986 7.10085 9.35986C5.77716 9.35986 4.7041 10.36 4.7041 11.5937C4.7041 12.8275 5.77716 13.8276 7.10085 13.8276Z",
    stroke: "#FCCE3D",
    fillOpacity: 0,
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70392 11.5936H1.32617",
    fillOpacity: 0,
    stroke: "#FCCE3D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6282 11.5936H9.68652",
    fillOpacity: 0,
    stroke: "#FCCE3D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85378 6.03499C11.1775 6.03499 12.2505 5.03485 12.2505 3.80113C12.2505 2.5674 11.1775 1.56726 9.85378 1.56726C8.53009 1.56726 7.45703 2.5674 7.45703 3.80113C7.45703 5.03485 8.53009 6.03499 9.85378 6.03499Z",
    stroke: "#FCCE3D",
    fillOpacity: 0,
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2617 3.80115H15.6395",
    fillOpacity: 0,
    stroke: "#FCCE3D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32617 3.80115H7.26788",
    fillOpacity: 0,
    stroke: "#FCCE3D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.b2c01625f9eed7605d8d0097f2142523.svg";
export { ForwardRef as ReactComponent };